<template>
  <v-dialog
    v-model="modalState"
    transition="dialog-bottom-transition"
    persistent
    width="1000"
  >
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ $t("order_update") }}</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mt-4">
        <v-row class="pa-0">
          <v-col cols="12">
            <v-text-field
              :label="$t('number_of_box')"
              v-model="formData.numberOfBoxes"
              type="number"
              dense
              outlined
              @change="() => validateMinValue('numberOfBoxes', 0)"
              min="0"
            />
          </v-col>
          <v-col cols="12">
            <ActionBuilder
              :query="formData.boxes"
              :length="parseInt(formData.numberOfBoxes)"
              ref="actionBuilder"
            />
          </v-col>
        </v-row>
        <!--begin::Actions-->
        <div class="my-4 d-flex flex-grow-1 align-end justify-center">
          <button
            @click.prevent="clearFields"
            type="reset"
            class="btn btn-light me-3 px-5 py-3 ls1"
          >
            Clear
          </button>
          <button
            @click.prevent="submitStatusUpdate"
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
import ActionBuilder from "@/own/components/fulfillment/orders/actionBuilder/ActionBuilder.vue";
import { SET_BOXES_DIMENSIONS_ADDED } from "@/core/services/store/orders.module";

export default {
  name: "NumberOfBoxModal",
  components: { ActionBuilder },
  props: {
    refresher: { required: true, type: Function },
  },
  mixins: [fieldValueValidation],
  data: () => ({
    modalState: false,
    formData: {
      ordersId: null,
      numberOfBoxes: 0,
      boxes: [],
    },
  }),
  mounted() {
    this.$store.commit(SET_BOXES_DIMENSIONS_ADDED, true);
  },
  methods: {
    toggleModal(data) {
      // console.log(data);
      if (!this.modalState) {
        this.formData.ordersId = data.order.id;
        this.formData.numberOfBoxes = data.order.numberOfBoxes;
        this.formData.boxes = data.order.boxes;
      } else this.clearFields();
      this.modalState = !this.modalState;
    },

    submitStatusUpdate() {
      let hasDimension = true;
      this.formData.boxes.forEach((box) => {
        if (hasDimension) {
          Object.values(box).forEach((value) => {
            if (!value && hasDimension) {
              hasDimension = false;
            }
          });
        }
      });
      if (!hasDimension) {
        Swal.fire({
          title: "Warning",
          html: `<div>Please, add box details!</div>`,
          icon: "warning",
          showConfirmButton: false,
          timer: 2500,
        });
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);

      ApiService.post(`/fulfillment/orders/update_order_client_save`, {
        ...this.formData,
      })
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "Order is updated",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.refresher();
          this.toggleModal();
        })
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    clearFields() {
      this.formData = {
        ordersId: null,
        numberOfBoxes: 0,
        boxes: [],
      };
    },
  },
};
</script>
